import React from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useTheme } from '../contexts/ThemeContext';
import { ThemeToggle } from './ThemeToggle';
import PillNav from './PillNav';

const ThemeToggleContainer = styled.div`
  position: fixed;
  top: 1.75rem;
  right: 2rem;
  z-index: 1001;

  @media (max-width: 768px) {
    top: 1.5rem;
    right: 1rem;
  }
`;

const navItems = [
  { label: 'Projects', href: '/projects' },
  { label: 'Articles', href: '/articles' },
  { label: 'Contact', href: '/contact' }
];

export const Navigation = () => {
  const location = useLocation();
  const { isDarkMode } = useTheme();

  // Theme-based colors
  const baseColor = isDarkMode ? '#ffffff' : '#000000';
  const pillColor = isDarkMode ? '#ffffff' : '#000000';
  const hoveredPillTextColor = isDarkMode ? '#000000' : '#ffffff';

  return (
    <>
      <PillNav
        logo="/logo-ed.svg"
        logoAlt="Edwin Riwaldo Logo"
        items={navItems}
        activeHref={location.pathname}
        baseColor={baseColor}
        pillColor={pillColor}
        hoveredPillTextColor={hoveredPillTextColor}
        ease="power2.easeOut"
        className="main-navigation"
        isDarkMode={isDarkMode}
      />
      <ThemeToggleContainer>
        <ThemeToggle />
      </ThemeToggleContainer>
    </>
  );
};